export class OrganizationImpactType {
  public id: string;
  public name: string;

  constructor(data: Partial<OrganizationImpactType> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: any = {}): OrganizationImpactType {
    return new OrganizationImpactType({
      id: data?.id ?? '',
      name: data?.name ?? data?.title ?? '',
    });
  }

  public processForApi(): Record<string, any> {
    return {
      id: this.id,
      title: this.name,
    };
  }
}
